<template>
  <div class="flex flex-col gap-1">
    <template v-for="block in blocks" :key="block.type">
      <ChatTextBlock v-if="block.type === 'text'" :markdown="block.markdown" />
      <ChatSelectTagsBlock v-else-if="block.type === 'selectTags'" :disabled="disabled" :tags="block.tags" @select="$emit('selectTag', $event)" />
      <ChatNavigationBlock v-else-if="block.type === 'navigation'" :label="block.label" :nav-type="block.navType" :url="block.url" @click="$emit('clickNavigation', $event)" />
      <ChatErrorBlock v-else-if="block.type === 'error'" :message="block.message" />
    </template>
  </div>
</template>

<script setup lang="ts">
import ChatErrorBlock from '@/wabunka-src/features/Chat/components/model/pure/blocks/ChatErrorBlock/ChatErrorBlock.vue';
import ChatNavigationBlock from '@/wabunka-src/features/Chat/components/model/pure/blocks/ChatNavigationBlock/ChatNavigationBlock.vue';
import ChatSelectTagsBlock from '@/wabunka-src/features/Chat/components/model/pure/blocks/ChatSelectTagsBlock/ChatSelectTagsBlock.vue';
import ChatTextBlock from '@/wabunka-src/features/Chat/components/model/pure/blocks/ChatTextBlock/ChatTextBlock.vue';
import type { MessageBlock } from '@/wabunka-src/features/Chat/models/chatMessage';

interface Props {
  blocks: MessageBlock[];
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

defineEmits<{
  selectTag: [tag: string];
  clickNavigation: [payload: { navType: string; url?: string; label?: string }];
}>();
</script>
